// ITEM 목록 불러오기
export const RECEIVE_ITEMS = "GUESTBOOK_COMMENT_TRASH_RECEIVE_ITEMS";

// ITEM 클리어
export const CLEAR_ITEMS = "GUESTBOOK_COMMENT_TRASH_CLEAR_ITEMS";

// 키워드 검색
export const SEARCH_KEYWORD = "GUESTBOOK_COMMENT_TRASH_SEARCH_KEYWORD";

// 하나의 ITEM 선택 (체크박스)
export const SELECT_ITEM = "GUESTBOOK_COMMENT_TRASH_SELECT_ITEM";

// 하나의 ITEM 선택 해제 (체크박스)
export const DESELECT_ITEM = "GUESTBOOK_COMMENT_TRASH_DESELECT_ITEM";

// 모든 ITEM 선택 (전체선택) (리스트의 ITEM 체크)
export const SELECT_ALL_ITEMS = "GUESTBOOK_COMMENT_TRASH_SELECT_ALL_ITEMS";

// 모든 ITEM 선택 해제 (전체선택 해제) (리스트의 ITEM 선택 해제)
export const DESELECT_ALL_ITEMS = "GUESTBOOK_COMMENT_TRASH_DESELECT_ALL_ITEMS";

// 하나의 ITEM 의 더보기(more option) 활성화
export const TOGGLE_MORE_BUTTON = "GUESTBOOK_COMMENT_TRASH_TOGGLE_MORE_BUTTON";

// 하나의 ITEM 의 상태 변경 더보기 활성화
export const TOGGLE_CHANGE_STATUS_BUTTON = "GUESTBOOK_COMMENT_TRASH_TOGGLE_CHANGE_STATUS_BUTTON";

// 하나의 ITEM 상태 변경
export const UPDATE_ITEM = "GUESTBOOK_COMMENT_TRASH_UPDATE_ITEM";

// 여러개의 ITEM 상태 변경
export const UPDATE_SELECTED_ITEMS = "GUESTBOOK_COMMENT_TRASH_UPDATE_SELECTED_ITEMS";

// 여러개의 ITEM 삭제
export const DELETE_SELECTED_ITEMS = "GUESTBOOK_COMMENT_TRASH_DELETE_SELECTED_ITEMS";

// 하나의 ITEM 삭제
export const DELETE_ITEM = "GUESTBOOK_COMMENT_TRASH_DELETE_ITEM";
